import { formatWorkflow } from '@parsys/frontend_library';

import { API_WORKFLOW_PATH } from 'FRONTEND/utils/routes';

// For the moment we only need the workflow to display the consultation summary.
// Consultation creation goes through vanilla HTML forms sent by the backend through templates.
// We fetch the workflow with the version that is stored in the consultation we want to display.
export const getWorkflowVersion = async({ id, version }) => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  };
  const response = await fetch(`${API_WORKFLOW_PATH}${id}/?${version?.toString() ? `version=${version}` : ''}&semver=true`, options);
  const responseData = await response.json();
  // The FL formatWorkflow function returns [formattedWorkflow, biologicalTests]. The biologicalTests are only for MC.
  return formatWorkflow(responseData)[0];
};
